/** Business K-1 package — doc_type / folder_type (document_category: business). */
export const DOC_TYPE_K1_PACKAGE = "k1_package";

/** Business Filed Copies UI tab id. */
export const K1_PACKAGE_PURPOSE_TAB = "k1_package";

/** Individual Filed Copies — doc_type / folder_type (document_category: individual). */
export const DOC_TYPE_FILED_COPIES = "filed_copies";

/** Individual Filed Copies UI tab id. */
export const FILED_COPIES_PURPOSE_TAB = "filed_copies";

/** User-facing label for Filed Copies tabs (individual and business). */
export const K1_PACKAGE_TAB_LABEL = "Filed Copies";

export function isK1PackagePurposeTab(purposeTab) {
  return purposeTab === K1_PACKAGE_PURPOSE_TAB;
}

export function isIndividualFiledCopiesPurposeTab(purposeTab) {
  return purposeTab === FILED_COPIES_PURPOSE_TAB;
}

export function isFiledCopiesPurposeTab(purposeTab) {
  return isK1PackagePurposeTab(purposeTab) || isIndividualFiledCopiesPurposeTab(purposeTab);
}

/** Map Filed Copies purpose tab to backend doc_type / folder_type. */
export function docTypeForFiledCopiesPurposeTab(purposeTab) {
  if (isK1PackagePurposeTab(purposeTab)) return DOC_TYPE_K1_PACKAGE;
  if (isIndividualFiledCopiesPurposeTab(purposeTab)) return DOC_TYPE_FILED_COPIES;
  return null;
}

/** Filed Copies purpose tab for a document category. */
export function filedCopiesPurposeTabForCategory(documentCategory) {
  return normalizeDocumentCategory(documentCategory) === "business"
    ? K1_PACKAGE_PURPOSE_TAB
    : FILED_COPIES_PURPOSE_TAB;
}

export function isInternalPurposeDocType(docType) {
  const dt = String(docType || "").toLowerCase();
  return (
    dt === "office" ||
    dt === DOC_TYPE_K1_PACKAGE ||
    dt === DOC_TYPE_FILED_COPIES
  );
}

/** Map staff document tab to folder_type / doc_type. */
export function resolveStaffDocTypeFromPurpose(purposeTab) {
  if (purposeTab === "received") return "client";
  if (purposeTab === "office") return "office";
  const filedCopiesDocType = docTypeForFiledCopiesPurposeTab(purposeTab);
  if (filedCopiesDocType) return filedCopiesDocType;
  return "emp";
}

/** Map folder_type / doc_type back to sent / received / office / filed-copies tabs. */
export function purposeTabFromDocType(docType) {
  const dt = String(docType || "").toLowerCase();
  if (dt === "client") return "received";
  if (dt === "office") return "office";
  if (dt === DOC_TYPE_K1_PACKAGE) return K1_PACKAGE_PURPOSE_TAB;
  if (dt === DOC_TYPE_FILED_COPIES) return FILED_COPIES_PURPOSE_TAB;
  return "sent";
}

export function normalizeDocumentCategory(value) {
  const s = String(value || "").toLowerCase();
  return s === "business" ? "business" : "individual";
}

/** document_category for move-modal folder fetch. */
export function categoryForMoveFetch(purposeTab, categoryTab) {
  if (purposeTab === "office") return undefined;
  if (isK1PackagePurposeTab(purposeTab)) return "business";
  if (isIndividualFiledCopiesPurposeTab(purposeTab)) return "individual";
  return normalizeDocumentCategory(categoryTab);
}

/** Whether getUserFiles/getUserFolders should send document_category for this doc_type. */
export function shouldIncludeDocumentCategoryInFetch(docType) {
  return String(docType || "").toLowerCase() !== "office";
}

export function getWantedDocTypeForPurposeTab(purposeTab) {
  if (purposeTab === "sent") return "emp";
  if (purposeTab === "received") return "client";
  if (purposeTab === "office") return "office";
  return docTypeForFiledCopiesPurposeTab(purposeTab);
}

export function matchesPurposeTabFolder(folder, purposeTab) {
  const ft = folder?.folder_type;
  if (purposeTab === "sent") return ft === "emp";
  if (purposeTab === "received") return ft === "client";
  if (purposeTab === "office") return ft === "office";
  const filedCopiesDocType = docTypeForFiledCopiesPurposeTab(purposeTab);
  if (filedCopiesDocType) return ft === filedCopiesDocType;
  return true;
}

export function matchesPurposeTabFile(file, purposeTab) {
  const dt = file?.doc_type;
  if (purposeTab === "sent") return !dt || dt === "emp";
  if (purposeTab === "received") return !dt || dt === "client";
  if (purposeTab === "office") return dt === "office";
  const filedCopiesDocType = docTypeForFiledCopiesPurposeTab(purposeTab);
  if (filedCopiesDocType) return dt === filedCopiesDocType;
  return true;
}

export function resolveDocumentModalContextTab(docFileType, folderModalContext) {
  if (folderModalContext) return folderModalContext;
  if (docFileType === "office") return "office";
  if (isFiledCopiesPurposeTab(docFileType)) return docFileType;
  if (docFileType === "received") return "received";
  return "sent";
}

const ROOT_UPLOAD_TAX_YEAR_FOLDER_OPTIONS = [
  { id: "Tax Year 2021", value: "Tax Year 2021" },
  { id: "Tax Year 2022", value: "Tax Year 2022" },
  { id: "Tax Year 2023", value: "Tax Year 2023" },
  { id: "Tax Year 2024", value: "Tax Year 2024" },
  { id: "Tax Year 2025", value: "Tax Year 2025" },
  { id: "Tax Year 2026", value: "Tax Year 2026" },
];

const ROOT_UPLOAD_BUSINESS_FOLDER_OPTIONS = [
  { id: "Incorporation", value: "Incorporation" },
];

/** Root "Upload Files" folder-name dropdown (business adds Incorporation). */
export function getRootUploadFolderDropdownOptions(documentCategory) {
  if (normalizeDocumentCategory(documentCategory) === "business") {
    return [
      ...ROOT_UPLOAD_TAX_YEAR_FOLDER_OPTIONS,
      ...ROOT_UPLOAD_BUSINESS_FOLDER_OPTIONS,
    ];
  }
  return ROOT_UPLOAD_TAX_YEAR_FOLDER_OPTIONS;
}
